import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { ReceitaResponseDTO, ReceitaDTO, ReceitaFiltrosDTO, ReceitaDashboardResponseDTO, TotalMoedaReceitaDTO } from '../../models/gerenciar-contas/receita.model';

@Injectable({
  providedIn: 'root',
})
export class ReceitaService {
  constructor(private apiService: ApiService) { }

  get(url: string, data?: any): Observable<ReceitaResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const path = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<ReceitaResponseDTO>(path);
  }
  getById<T>(url: string): Observable<ReceitaDTO> {
    return this.apiService.read<ReceitaDTO>(url);
  }

  post<T>(url: string, data: ReceitaDTO): Observable<ReceitaDTO> {
    return this.apiService.create<ReceitaDTO>(url, data);
  }

  put<T>(url: string, data: ReceitaDTO): Observable<ReceitaDTO> {
    return this.apiService.update<ReceitaDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }

  buscar(geral: string, page: number, size: number): Observable<ReceitaResponseDTO> {
    return this.get('/movimento/buscar', {
      geral,
      page,
      size,
      tipoDeTransacao: 'RECEITA'
    });
  }

  /** Listar receitas com filtros server-side */
  listarComFiltros(filtros: ReceitaFiltrosDTO): Observable<ReceitaDashboardResponseDTO> {
    const params: any = {};
    if (filtros.conta != null) params.conta = filtros.conta;
    if (filtros.dataInicio) params.dataInicio = filtros.dataInicio;
    if (filtros.dataFim) params.dataFim = filtros.dataFim;
    if (filtros.observacao) params.observacao = filtros.observacao;
    if (filtros.tipoReceita) params.tipoReceita = filtros.tipoReceita;
    if (filtros.pessoaId != null) params.pessoaId = filtros.pessoaId;
    if (filtros.page != null) params.page = filtros.page;
    if (filtros.size != null) params.size = filtros.size;
    if (filtros.sort) params.sort = filtros.sort;

    const queryParams = this.apiService.buildQueryParams(params);
    const path = queryParams
      ? `/totaldashboard/listarReceitasPorFiltros?${queryParams}`
      : '/totaldashboard/listarReceitasPorFiltros';
    return this.apiService.read<ReceitaDashboardResponseDTO>(path);
  }

  /** Buscar totais por moeda */
  getTotaisPorMoeda(filtros: ReceitaFiltrosDTO): Observable<TotalMoedaReceitaDTO> {
    const params: any = {};
    if (filtros.conta != null) params.conta = filtros.conta;
    if (filtros.dataInicio) params.dataInicio = filtros.dataInicio;
    if (filtros.dataFim) params.dataFim = filtros.dataFim;
    if (filtros.observacao) params.observacao = filtros.observacao;
    if (filtros.tipoReceita) params.tipoReceita = filtros.tipoReceita;
    if (filtros.pessoaId != null) params.pessoaId = filtros.pessoaId;

    const queryParams = this.apiService.buildQueryParams(params);
    const path = queryParams
      ? `/totaldashboard/total-receitas?${queryParams}`
      : '/totaldashboard/total-receitas';
    return this.apiService.read<TotalMoedaReceitaDTO>(path);
  }

  /** Gerar PDF de movimento (retorna base64) */
  gerarPdfMovimento(id: number, tipoImpressao: string): Observable<string> {
    return this.apiService.postText(`/movimento/gerar-pdf-movimento/${id}/impressao/${tipoImpressao}`);
  }
}
